import classNames from "classnames";
import React from "react";

const PaginationDots = ({ pages, currentPageIndex }) => (
  <div className={"slide-indicator-container"}>
    <div className={"slide-indicator"}>
      {pages.map((_item, index) => {
        let dotClasses = classNames("dot", {
          current: currentPageIndex === index
        });
        return <span className={dotClasses} key={index} />;
      })}
    </div>
  </div>
);

export default PaginationDots;
